import { getLogger } from '../logger';

const logger = getLogger('intercomTracker');

export let logEvent = (_eventName, _meta) => logger.warn('IntercomTracker not initialized for client');
// logEvent function should expect 'eventName' and 'meta' props after being initialized

export const registerEventDispatcher = (func) => {
  logEvent = (eventName, meta) => {
    logger.log('Tracking Intercom Event:', eventName);
    func(eventName, meta);
  };
};
